import { createNetworkRequestHook } from '@/utils/createNetworkRequestHook'

export interface DashboardStats {
  assets: {
    all: number
    myVehicles: number
    myPtus: number
    vehiclesSharedWithMe: number
    ptusSharedWithMe: number
  }
  shares: {
    allActive: number
    lent: number
    borrowed: number
    onward: number
  }
  contacts: {
    all: number
    sharedFromMe: number
    sharedToMe: number
  }
}

const baseUrl = 'v1/organizations/me/dashboard'

export const useDashboard = createNetworkRequestHook<DashboardStats>(`${baseUrl}/`)
